export function formatText(username: string | undefined | null) {
  if (username == null) {
    return "<null>";
  }

  return username.trim() || '<empty>';
}
